import { render, staticRenderFns } from "./CCMAttachmentAdd.vue?vue&type=template&id=3a59b4d4"
import script from "./CCMAttachmentAdd.vue?vue&type=script&lang=js"
export * from "./CCMAttachmentAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports